export const sessionStorageEffect =
  (key: string) =>
  ({
    setSelf,
    onSet
  }: {
    setSelf: (value: any) => void;
    onSet: (
      callback: (newValue: any, oldValue: any, isReset: boolean) => void
    ) => void;
  }) => {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue != null) {
      try {
        setSelf(JSON.parse(savedValue));
      } catch (e) {
        console.error('Failed to parse stored value:', e);
        sessionStorage.removeItem(key);
      }
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };
